module.exports = __webpack_public_path__ + "static/Image24@2x-60e0e21782687e85d1939b87c7aacc5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image24@2x.jpg
// module id = 917
// module chunks = 227233210825294 244429959259914